import React from "react";

import { format } from "date-fns";

import { Box } from "@chakra-ui/react";

import { InfoPessoa } from "./InfoPessoa";
import { Horarios } from "../Horarios";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

export const Equipe = ({ data }) => {
  const columnsER = [
    {
      Header: "Função",
      accessor: "funcaoEquipeAcolhimento",
      Cell: (props) => {
        return <span>{props.value.nomeFuncao}</span>;
      },
    },
    {
      Header: "Telefone",
      accessor: "telefone",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Carga horária semanal",
      accessor: "cargaHorariaSemanal",
      Cell: (props) => {
        return <span>{props.value}h</span>;
      },
    },
    {
      Header: "Início das atividades",
      accessor: "inicioAtividade",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
  ];

  const columnsDPSD = [
    {
      Header: "Cargo",
      accessor: "cargoEquipeAcolhimento",
      Cell: (props) => {
        return <span>{props.value.nomeCargo}</span>;
      },
    },
    {
      Header: "Função",
      accessor: "funcaoEquipeAcolhimento",
      Cell: (props) => {
        return <span>{props.value ? props.value.nomeFuncao : ""}</span>;
      },
    },
    {
      Header: "Carga horária semanal",
      accessor: "cargaHorariaSemanal",
      Cell: (props) => {
        return <span>{props.value}h</span>;
      },
    },
    {
      Header: "Início das atividades",
      accessor: "inicioAtividade",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Regime de Trabalho",
      accessor: "regimeTrabalhoAcolhimento",
      Cell: (props) => {
        return <span>{props.value.nomeRegime}</span>;
      },
    },
  ];

  const columnsDPSP = [
    {
      Header: "Cargo",
      accessor: "cargoEquipeAcolhimento",
      Cell: (props) => {
        return <span>{props.value.nomeCargo}</span>;
      },
    },
    {
      Header: "Função",
      accessor: "funcaoEquipeAcolhimento",
      Cell: (props) => {
        return <span>{props.value ? props.value.nomeFuncao : ""}</span>;
      },
    },
    {
      Header: "Carga horária semanal",
      accessor: "cargaHorariaSemanal",
      Cell: (props) => {
        return <span>{props.value}h</span>;
      },
    },
    {
      Header: "Início das atividades",
      accessor: "inicioAtividade",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Regime de Trabalho",
      accessor: "regimeTrabalhoAcolhimento",
      Cell: (props) => {
        return <span>{props.value.nomeRegime}</span>;
      },
    },
    {
      Header: "Regime de Plantão",
      accessor: "regimePlantaoAcolhimento",
      Cell: (props) => {
        if (props.value.nomeRegime !== "outro") {
          return <span>{props.value.nomeRegime}</span>;
        } else {
          return <span>{props.row.original.outroRegimePlantao}</span>;
        }
      },
    },
  ];

  if (Array.isArray(data) && data.length === 0) {
    data = null;
  }

  return data ? (
    <Box display="block">
      {data.find(
        (membro) =>
          membro.tipoEquipeAcolhimento.nomeEquipe === "Equipe de Referência"
      ) && (
        <Box className="break-page">
          <Group
            bgColor="#DDEBEA"
            title="Equipe de Referência"
            mt="15px"
            py="12px"
            mtDivider="5px"
          >
            {data
              .filter(
                (membro) =>
                  membro.tipoEquipeAcolhimento.nomeEquipe ===
                  "Equipe de Referência"
              )
              .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
              .map((membro, index) => (
                <Box key={index}>
                  <InfoPessoa
                    name={membro.nome}
                    data={[membro]}
                    columns={columnsER}
                  />
                  <Horarios horarios={membro.listaHorarios} />
                </Box>
              ))}
          </Group>
        </Box>
      )}
      {data.find(
        (membro) =>
          membro.tipoEquipeAcolhimento.nomeEquipe ===
          "Demais profissionais do Serviço"
      ) && (
        <Box className="break-page">
          <Group
            bgColor="#DDEBEA"
            title="Demais profissionais do serviço"
            mt="15px"
            py="12px"
            mtDivider="5px"
          >
            {data
              .filter(
                (membro) =>
                  membro.tipoEquipeAcolhimento.nomeEquipe ===
                  "Demais profissionais do Serviço"
              )
              .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
              .map((membro, index) => (
                <Box key={index}>
                  <InfoPessoa
                    name={membro.nome}
                    data={[membro]}
                    columns={
                      membro.regimeTrabalhoAcolhimento.nomeRegime === "Diarista"
                        ? columnsDPSD
                        : columnsDPSP
                    }
                  />
                  {membro.regimeTrabalhoAcolhimento.nomeRegime ===
                    "Diarista" && <Horarios horarios={membro.listaHorarios} />}
                </Box>
              ))}
          </Group>
        </Box>
      )}
    </Box>
  ) : (
    <Box display="block">
      <Group
        bgColor="#DDEBEA"
        title="Equipe"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
